var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroupActions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.5 -34.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-156.46,38.47V34.5H-170.5V49.53h3.96V52.5h14.04V38.47Zm2.81,12.88h-11.74V47.5h-1.15v.88h-2.81V35.65h11.74v2.82h-8.93V42.5h1.15V39.62h11.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-157.14,45.24l-3.47,3.47-.79-.8,2.18-2.08h-8.62V44.64h8.62l-2.18-2.08.79-.79Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroupActions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/group-actions.e99565e665cf27991b080d3cc81184c0.svg";